<template>
  <v-app v-if="!init" class="py-2">
    <v-content style="margin-left: 35px; margin-right: 35px;">
      <Header class="mb-5"/>
      <CardView v-if="cardView"/>
      <ListView v-else/>
      <div class="">
        <TablePagination 
          ref="tablePagination"
          @loadData="loadData" 
          @loadPerPage="loadPerPage"
          :perPage="pageSize"
          :totalItems="totalData"
          showDropdownPerPage
          title="document(s)"
        />
      </div>
      <Lightbox/>
      <Snackbar/>
    </v-content>
  </v-app>
</template>

<script>
import Header from './components/document_library/header.vue'
import CardView from './components/document_library/card_view.vue'
import ListView from './components/document_library/list_view.vue'
import Snackbar from './components/snackbar'
import Lightbox from './components/document_library/lightbox.vue'
import TablePagination from './components/table-pagination.vue'

import { mapMutations } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  components: { CardView, ListView, Header, Snackbar, Lightbox, TablePagination },
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    org_id() {
      return this.$store.state.organization.id
    },
    cardView() {
      return this.$store.state.cardView
    },
    sort() {
      return this.$store.state.sort
    },
    page: {
      get: function() {
        return this.$store.state.page
      },
      set: function(newValue){
        this.$store.commit('changePage', newValue)
      }
    },
    totalPages() {
      return this.$store.state.totalPages
    },
    query() {
      return this.$store.state.query
    },
    showLightbox() {
      return this.$store.state.showLightbox
    },
    totalData() {
      return this.$store.state.documentTotal
    },
    pageSize() {
      return this.$store.state.pageSize
    },
  },
  methods: {
    changePage() {
      this.$store.dispatch('getDocuments')
    },
    loadData(newPage) {
      this.page = newPage;
      this.changePage();
    },
    loadPerPage(newPageSize) {
      this.$store.commit('setPageSize', newPageSize);
      this.$store.commit('changePage', 1);
      if (this.$refs && this.$refs.tablePagination) {
        this.$refs.tablePagination.isActive = 1;
        this.$refs.tablePagination.updateShowingItem();
      }
      this.updateURLParams();
      this.changePage();
    },
    resetPage() {
      this.$store.commit('changePage', 1);
      this.$store.commit('setPageSize', 15);
      this.changePage();
    },
    updateURLParams() {
      this.$router.push({ query: { page: this.page, perPage: this.pageSize } });
    },
    openDocumentFromQuery(documentId) {
      this.axios.get(`/supporting_documents/${documentId}.json`)
        .then(response => {
          this.$store.commit('changeEditedDocument', response.data);
          this.$store.commit('toggleShowLightbox', true);
        });
    },
  },
  created() {
    this.resetPage();

    // prevent accessGroup to access client profile
    const accessGroup = this.currentUser.access_group;
    if (accessGroup && !accessGroup['sidebar_settings']['documents']) {
      window.location.href = '/dashboard';
    } else {
      this.init = false;
    }

    if (this.$route.query.document_id) {
      this.openDocumentFromQuery(this.$route.query.document_id);
    }
  },
  data () {
    return {
      init: true
    }
  },
}
</script>
